import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputAdornment, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useI18n } from 'locales';
import PropTypes from 'prop-types';

const StyledInput = styled(TextField)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
  },
}));

function SearchInput({ value, onClear, ...props }) {
  const t = useI18n();

  return (
    <StyledInput
      variant='standard'
      placeholder={`${t('Search')}...`}
      slotProps={{
        input: {
          startAdornment: <InputAdornment position='start' sx={{ ml: 1 }}><FontAwesomeIcon icon={faSearch} /></InputAdornment>,
          endAdornment: value ? <InputAdornment position='end' sx={{ mr: 1 }}><FontAwesomeIcon icon={faTimes} onClick={() => onClear && onClear()} /></InputAdornment> : null,
        }
      }}
      value={value}
      {...props}
    />
  );
}

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SearchInput;
